import { CompleteBatchReportUploadInput, CompleteUploadRequest, CompleteUploadRequestList } from "@amzn/coral_com-amazon-transreportscenterservice";
import { FILE_PARTS_UPLOAD_SUCCESS } from "../actions/types";
import { UPLOAD_STATUS } from "../constants/upload";
import { completeBulkUploadFilesAction } from "../actions";
/**
 * custom middleware to check authorization on dispatch.
 * @returns {function({dispatch: *}): function(*): function(*): *}
 */ function completeBulkFileUploadMiddleware(param) {
    var getState = param.getState;
    return function(next) {
        return function(action) {
            var _store_reportsCenter;
            var result = next(action);
            var store = getState();
            var type = action.type;
            var _store_reportsCenter_bulkFilesPartsUpload;
            var bulkFilesPartsUpload = (_store_reportsCenter_bulkFilesPartsUpload = store === null || store === void 0 ? void 0 : (_store_reportsCenter = store.reportsCenter) === null || _store_reportsCenter === void 0 ? void 0 : _store_reportsCenter.bulkFilesPartsUpload) !== null && _store_reportsCenter_bulkFilesPartsUpload !== void 0 ? _store_reportsCenter_bulkFilesPartsUpload : {};
            var bulkFilesKeys = Object.keys(bulkFilesPartsUpload);
            var bulkFilesUploadValues = Object.values(bulkFilesPartsUpload);
            var isBulkFilesPartUploadComplete = bulkFilesKeys.length && bulkFilesUploadValues.every(function(val) {
                return val.status === UPLOAD_STATUS.SUCCESS;
            });
            if (type === FILE_PARTS_UPLOAD_SUCCESS && isBulkFilesPartUploadComplete) {
                var completeBatchReportUploadInput = CompleteBatchReportUploadInput.clone({
                    logisticsPartyId: bulkFilesUploadValues[0].logisticsPartyId,
                    reportType: bulkFilesUploadValues[0].reportType,
                    term: bulkFilesUploadValues[0].term,
                    CompleteUploadRequestList: CompleteUploadRequestList.fromJson(bulkFilesUploadValues.map(function(bulkFilesUploadValue) {
                        return CompleteUploadRequest.clone({
                            key: bulkFilesUploadValue.key,
                            uploadId: bulkFilesUploadValue.uploadId,
                            supportingDocumentInfo: bulkFilesUploadValue.supportingDocumentInfo,
                            eTags: bulkFilesUploadValue.eTags,
                            reportId: bulkFilesUploadValue.reportId
                        });
                    }))
                });
                return next(completeBulkUploadFilesAction.request({
                    completeBatchReportUploadInput: completeBatchReportUploadInput
                }));
            }
            return result;
        };
    };
}
export default completeBulkFileUploadMiddleware;

//# sourceMappingURL=completeBulkFileUploadMiddleware.js.map